export default __webpack_public_path__ + "static/media/attention.3af5269d.svg";